import React from "react";
import { Outlet } from "react-router-dom";
import MenubarAdmin from "./MenubarAdmin";
import "./Adminlayout.css";


const AdminLayout = () => {
  return (
    <div className="container-fluid">
      <div className="row mt-1">
        <div className="col-md-2 admin-layout-sidebar">
          <MenubarAdmin />
        </div>
        <div className="col-md-10 admin-layout-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;